import classNames from "classnames";
import React, { useEffect, useState } from "react";
import ReactInputMask from "react-input-mask";
import Switch from "react-switch";
import toast from "react-hot-toast";
import clinicService from "../../../Services/clinicService";
import { t } from "../../../Utils/translate";
import utils from "../../../Utils";
import strings from "../../../Utils/strings";
import Widgets from "../../../Widgets";
import "../clinic.css";
import "../clinicTiming/clinicTiming.css";
import EditTimingPopupWarning from "../editTimingWarningPopup";

function DoctorTiming({ closeTiming, isEditTiming, doctorId, isEdited }) {
  const inputTypeFrom = "FROM";
  const inputTypeTo = "TO";
  const [originalDayList, setOriginalDayList] = useState([]);
  const [dayList, setDayList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditTimingValue, setIsEditTimingValue] = useState(null);
  const [showTimeEditWarning, setShowTimeEditWarning] = useState(false);
  const [doctorIdValue, setDoctorIdValue] = useState(null);
  const [appointmentTotalCount, setAppointmentTotalCount] = useState(0);
  const [appointmentRequestedCount, setAppointmentRequestedCount] = useState(0);
  const [appointmentCount, setAppointmentCount] = useState(0);
  const [appointmentPatientCount, setAppointmentPatientCount] = useState(0);
  const [isValidInput, setIsValidInput] = useState(true);

  useEffect(() => {
    setDoctorIdValue(doctorId ? doctorId : null);
    setUpDayList(doctorId);
  }, [doctorId]);

  useEffect(() => {
    setIsEditTimingValue(isEditTiming ? true : false);
  }, [isEditTiming]);

  async function getTiming() {
    try {
      const emptyDayList = [
        {
          day: utils.constants.doctorTiming.label_monday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: utils.constants.doctorTiming.label_tuesday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: strings.clinicTiming.label_wednesday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: strings.clinicTiming.label_thursday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: strings.clinicTiming.label_friday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: strings.clinicTiming.label_saturday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: strings.clinicTiming.label_sunday,
          status: false,
          limit: 3,
          timing: [],
        },
      ];
      let response = await clinicService.getDoctorTiming();
      if (response) {
        if (response.clinicTimings && response.clinicTimings.length > 0) {
          let resArr = response.clinicTimings;
          let arr = utils.constants.dayList.map((o) => ({ ...o }));
          resArr.map((resItem, resIndx) => {
            arr.map((item, i) => {
              if (item.day.toUpperCase() == resItem.day.toUpperCase()) {
                let timeArr = [];
                resItem.timings.map((timeItem, timeIndx) => {
                  let startHr = timeItem.startHour.toString();
                  let startMin = timeItem.startMinute.toString();
                  let endHr = timeItem.endHour.toString();
                  let endMin = timeItem.endMinute.toString();
                  startHr = startHr && startHr.length == 1 ? "0" + startHr : startHr;
                  startMin = startMin && startMin.length == 1 ? "0" + startMin : startMin;
                  endHr = endHr && endHr.length == 1 ? "0" + endHr : endHr;
                  endMin = endMin && endMin.length == 1 ? "0" + endMin : endMin;
                  let timeObj = {
                    from: startHr + ":" + startMin,
                    to: endHr + ":" + endMin,
                  };
                  timeArr.push(timeObj);
                });
                let dd = [...item.timing];
                dd = timeArr;
                if (timeArr.length > 0) {
                  item.status = true;
                }
                item.timing = timeArr;
              }
            });
          });
          return arr.map((o) => ({ ...o }));
        } else {
          return emptyDayList;
        }
      } else {
        return emptyDayList;
      }
    } catch (e) {
      return false;
    }
  }

  async function mathClinicAndDoctorTiming(doctorTimingList) {
    try {
      const response = await getTiming();
      response.map((clinicItem, clinicIndex) => {
        doctorTimingList.map((doctorItem, doctorIndex) => {
          if (clinicItem.day.toUpperCase() === doctorItem.day.toUpperCase()) {
            doctorItem["isActive"] = clinicItem.status;
          }
        });
      });
      return doctorTimingList;
    } catch (e) {
      return doctorTimingList;
    }
  }

  async function setUpDayList(id) {
    try {
      let response = await getDoctorTiming(id);
      response = await mathClinicAndDoctorTiming(response);
      if (response) {
        setOriginalDayList(response);
      }
      let response2 = await getDoctorTiming(id);
      response2 = await mathClinicAndDoctorTiming(response2);
      if (response2) {
        const responseForDayList = response2.map((o) => ({ ...o }));
        setDayList(responseForDayList);
      }
    } catch (e) {}
  }

  async function getDoctorTiming(id) {
    try {
      const newId = id ? id : doctorIdValue;
      const emptyDayList = [
        {
          day: strings.clinicTiming.label_monday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: strings.clinicTiming.label_tuesday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: strings.clinicTiming.label_wednesday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: strings.clinicTiming.label_thursday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: strings.clinicTiming.label_friday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: strings.clinicTiming.label_saturday,
          status: false,
          limit: 3,
          timing: [],
        },
        {
          day: strings.clinicTiming.label_sunday,
          status: false,
          limit: 3,
          timing: [],
        },
      ];

      setIsLoading(true);
      let docResponse = await clinicService.getDoctorProfileView(newId);
      setIsLoading(false);
      if (docResponse && docResponse.doctorDetails && docResponse.doctorDetails.length > 0) {
        let arr = [];
        docResponse.doctorDetails.map((doc) => {
          if (doc.doctorTimings && doc.doctorTimings.length > 0) {
            let resArr = doc.doctorTimings;
            arr = utils.constants.dayList.map((o) => ({ ...o }));
            resArr.map((resItem, resIndx) => {
              arr.map((item, i) => {
                if (item.day.toUpperCase() == resItem.day.toUpperCase()) {
                  let timeArr = [];
                  resItem.timings.map((timeItem, timeIndx) => {
                    let startHr = timeItem.startHour.toString();
                    let startMin = timeItem.startMinute.toString();
                    let endHr = timeItem.endHour.toString();
                    let endMin = timeItem.endMinute.toString();
                    startHr = startHr && startHr.length == 1 ? "0" + startHr : startHr;
                    startMin = startMin && startMin.length == 1 ? "0" + startMin : startMin;
                    endHr = endHr && endHr.length == 1 ? "0" + endHr : endHr;
                    endMin = endMin && endMin.length == 1 ? "0" + endMin : endMin;
                    let timeObj = {
                      from: startHr + ":" + startMin,
                      to: endHr + ":" + endMin,
                      status: timeItem.isActive,
                    };

                    timeArr.push(timeObj);
                  });
                  let dd = [...item.timing];
                  dd = timeArr;
                  if (timeArr.length > 0) {
                    item.status = resItem.isActive;
                  }
                  item.timing = timeArr;
                }
              });
            });
            arr = arr.map((o) => ({ ...o }));
          } else {
            arr = emptyDayList;
          }
        });
        return arr;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  }

  const doctorTimingEnable = () => {
    let arr = dayList;
    let returnValue = false;
    arr.map((item, i) => {
      if (item.status) {
        item.timing.map((time) => {
          if (time.status) {
            returnValue = true;
          }
        });
      }
    });
    return returnValue;
  };

  const checkTimeCollision = (arr, editingTimeIndex) => {
    let returnValue = true;
    let fromArr = arr[editingTimeIndex].from.split(":");
    let toArr = arr[editingTimeIndex].to.split(":");
    if ((fromArr[0] != "" && fromArr[0] > 23) || (fromArr[1] != "" && fromArr[1] > 60) || (fromArr[1] !== "" && fromArr[1] > 60)) {
      returnValue = false;
    } else if ((toArr[0] != "" && toArr[0] > 23) || (toArr[0] != "" && toArr[0] > 60) || (toArr[1] !== "" && toArr[1] > 60)) {
      returnValue = false;
    }
  };

  function onCollisionCheck(inputType, value, item, timeArrIndex, dayArrIndex) {
    let dayListArr = [...dayList];
    let arr = [...item.timing];

    let res = utils.utilFunctions.checkTimeCollision(arr, timeArrIndex);
    if (!res) {
      toast.dismiss();
      toast.error(t("invalidTimeOrSlot"));
      if (inputType === strings.addDoctor.label_from) {
        arr[timeArrIndex] = {
          from: "__:__",
          to: arr[timeArrIndex].to,
        };
      } else if (inputType === strings.addDoctor.label_to) {
        arr[timeArrIndex] = {
          from: arr[timeArrIndex].from,
          to: "__:__",
        };
      }
      dayListArr[dayArrIndex].timing = arr;
      setDayList(dayListArr);
    }
  }

  async function setTiming() {
    try {
      var body = {
        doctorId: doctorIdValue,
        newTimings: utils.utilFunctions.getTime(dayList),
      };
      const response = await clinicService.updateNewDoctorTiming(body);
      if (response && response.status) {
        toast.dismiss();
        toast.success(t("doctorUpdateSuccessMsg"));
        closeTiming();
        if (isEdited) {
          isEdited();
        }
      }
    } catch (e) {
      console.log(e);
      toast.dismiss();
      toast.error(e.message);
    }
  }
  async function getAppointmentDetailsForDoctorTiming() {
    try {
      let response = await clinicService.getAppointmentDetailsForClinicTiming(doctorIdValue);
      if (response && response.status) {
        setAppointmentTotalCount(response.totalUpcomingAppointmentCount);
        setAppointmentCount(response.upcomingAcceptedAppointmentCount);
        setAppointmentRequestedCount(response.upcomingClinicPendingAppointmentCount);
        setAppointmentPatientCount(response.upcomingPatientPendingAppointmentCount);
      }
    } catch (e) {
      setIsLoading(false);
    }
  }

  async function updateTiming(showWarning) {
    try {
      setIsLoading(true);
      let arr = [...dayList];
      const isTimeEdited = JSON.stringify(arr) !== JSON.stringify(originalDayList);
      if (showWarning) {
        if (isTimeEdited) {
          setShowTimeEditWarning(true);
          getAppointmentDetailsForDoctorTiming();
        } else {
          setShowTimeEditWarning(false);
          await setTiming(isTimeEdited);
        }
      } else {
        setShowTimeEditWarning(false);
        await setTiming(isTimeEdited);
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  }

  function disableButton() {
    let emptyCount = 0;
    let arr = dayList;
    let returnValue = false;
    arr.map((item, i) => {
      if (item.status) {
        const timeStatusList = item.timing.map((obj) => obj.status);
        const timeStatusForDay = timeStatusList.some((value) => value === true);
      }

      if (item.timing && item.timing.length > 0 && item.status) {
        item.timing.map((item2, i2) => {
          let emptyTimeCount = 0;
          const fromWithUnderScore = item2.from.includes("_");
          const toWithUnderScore = item2.to.includes("_");
          if (item2.from === "00:00" || item2.from === "" || item2.to === "00:00" || item2.to === "" || fromWithUnderScore || toWithUnderScore) {
            returnValue = true;
          }
        });
      } else {
        emptyCount = emptyCount + 1;
      }
    });
    returnValue = emptyCount === 7 ? true : returnValue;

    if (JSON.stringify(arr) === JSON.stringify(originalDayList)) {
      returnValue = true;
    }

    return returnValue;
  }

  function setInputValue(inputType, value, item, timeArrIndex, dayArrIndex) {
    let dayListArr = [...dayList];
    let arr = [...item.timing];
    if (inputType == strings.addDoctor.label_from) {
      arr[timeArrIndex] = {
        from: value,
        to: arr[timeArrIndex].to,
      };
    } else if (inputType === strings.addDoctor.label_to) {
      arr[timeArrIndex] = {
        from: arr[timeArrIndex].from,
        to: value,
      };
    }
    dayListArr[dayArrIndex].timing = arr;
    setDayList(dayListArr);
  }

  const doctorTimingProps = () => {
    return utils.utilFunctions.getAppointmentWarningProps("editDoctorTimingWarning", "futureAppointment", appointmentTotalCount, appointmentCount, appointmentRequestedCount, appointmentPatientCount);
  };

  if (isEditTimingValue != null) {
    return (
      <div style={{ maxHeight: "90vh", overflowY: "auto" }}>
        <React.Fragment>
          {isLoading ? <Widgets.CircularLoader /> : null}
          {showTimeEditWarning ? (
            <Widgets.AppDialog
              dialogTitle={t("warning")}
              view={<EditTimingPopupWarning {...doctorTimingProps()} />}
              setVisibility={() => {
                setShowTimeEditWarning(false);
              }}
              dialogNegativeBtnText={t("btnCancel")}
              dialogNegativeBtnCall={() => {
                setShowTimeEditWarning(false);
              }}
              dialogPositiveBtnText={t("btnUpdate")}
              dialogPositiveBtnCall={() => {
                updateTiming(false);
              }}
              widthType={utils.constants.dialogWidthType.small}
            />
          ) : null}
          <div className="clinic-timing-item-container">
            {dayList.map((item, i) => {
              let dayToShow = "";
              switch (item.day) {
                case utils.constants.doctorTiming.label_monday:
                  dayToShow = t("Monday");
                  break;
                case utils.constants.doctorTiming.label_tuesday:
                  dayToShow = t("Tuesday");
                  break;
                case utils.constants.doctorTiming.label_wednesday:
                  dayToShow = t("Wednesday");
                  break;
                case utils.constants.doctorTiming.label_thursday:
                  dayToShow = t("Thursday");
                  break;
                case utils.constants.doctorTiming.label_friday:
                  dayToShow = t("Friday");
                  break;
                case utils.constants.doctorTiming.label_saturday:
                  dayToShow = t("Saturday");
                  break;
                case utils.constants.doctorTiming.label_sunday:
                  dayToShow = t("Sunday");
                  break;
                default:
                  dayToShow = item.day;
              }

              return (
                <div className="clinic-timing-item-view">
                  <div className="clinic-timing-boxes d-flex justify-content-between">
                    <span className="weekNames">{dayToShow}</span>
                    <Switch
                      onChange={() => {
                        let arr = [...dayList];
                        arr[i].status = !arr[i].status;
                        setDayList(arr);
                        doctorTimingEnable();
                      }}
                      checked={item.status}
                      uncheckedIcon={utils.appStyles.switchStyle.uncheckedIcon}
                      checkedIcon={utils.appStyles.switchStyle.checkedIcon}
                      handleDiameter={utils.appStyles.switchStyle.handleDiameter}
                      height={utils.appStyles.switchStyle.height}
                      width={utils.appStyles.switchStyle.width}
                      offHandleColor={utils.appStyles.switchStyle.offHandleColor}
                      onHandleColor={utils.appStyles.switchStyle.onHandleColor}
                      offColor={utils.appStyles.switchStyle.offColor}
                      onColor={utils.appStyles.switchStyle.onColor}
                      activeBoxShadow={utils.appStyles.switchStyle.activeBoxShadow}
                    />
                  </div>
                  {item.status &&
                    item.timing.map((item2, index) => {
                      let showDeleteButton = false;
                      if (item.timing.length === 1) {
                        showDeleteButton = false;
                      } else if (item.timing.length === 3) {
                        showDeleteButton = true;
                      } else if (item.timing.length === 2 && index === 1) {
                        showDeleteButton = true;
                      }
                      let fromValue = item2.from;
                      let toValue = item2.to;
                      return (
                        <div className="clinic-timing-boxes-2-parent">
                          <div className="clinic-timing-boxes-2 d-flex" style={{ height: "59.3px" }}>
                            <div className="clinic-timing-boxes-2-input-view">
                              <div className="clinic-timing-range-label">{t("labelFrom")}</div>
                              <ReactInputMask
                                placeholder={t("hh_mm")}
                                mask={"99:99"}
                                value={fromValue}
                                onBlur={(e) => {
                                  onCollisionCheck(strings.addDoctor.label_from, e.target.value, item, index, i);
                                }}
                                onChange={(e) => {
                                  setInputValue(strings.addDoctor.label_from, e.target.value, item, index, i);
                                }}
                                className="form-control time-input"
                              />
                            </div>
                            <div className="clinic-timing-boxes-2-input-view">
                              <div className="clinic-timing-range-label">{t("labelTo")}</div>
                              <ReactInputMask
                                placeholder={t("hh_mm")}
                                mask={"99:99"}
                                value={toValue}
                                onBlur={(e) => {
                                  onCollisionCheck(strings.clinicLogin.label_to, e.target.value, item, index, i);
                                }}
                                onChange={(e) => {
                                  setInputValue(
                                    strings.addDoctor.label_to,

                                    e.target.value,
                                    item,
                                    index,
                                    i,
                                  );
                                }}
                                className="form-control time-input"
                              />
                            </div>
                          </div>
                          {showDeleteButton ? (
                            <i
                              onClick={() => {
                                if (item.timing.length > 1) {
                                  let dayListArr = [...dayList];
                                  let arr = [...item.timing];
                                  arr.splice(index, 1);
                                  dayListArr[i].timing = arr;
                                  setDayList(dayListArr);
                                }
                              }}
                              className="ri-delete-bin-line icon-hover-bg icon-hover-bg-padding-horizontal"
                            />
                          ) : (
                            <i
                              onClick={() => {
                                if (item.timing.length < 3) {
                                  let dayListArr = [...dayList];
                                  let arr = [...item.timing];
                                  if (dayListArr[i].timing.length > 0) {
                                    let lastIndex = dayListArr[i].timing.length - 1;
                                    if (
                                      dayListArr[i].timing[lastIndex].from != "" &&
                                      dayListArr[i].timing[lastIndex].from != "00:00" &&
                                      dayListArr[i].timing[lastIndex].to != "" &&
                                      dayListArr[i].timing[lastIndex].t0 != "00:00"
                                    ) {
                                      arr.push(utils.constants.timeValue);
                                      dayListArr[i].timing = arr;
                                      setDayList(dayListArr);
                                    } else {
                                      toast.dismiss();
                                      toast.warning(t("pleaseFillTheSlot"));
                                    }
                                  } else {
                                    arr.push(utils.constants.timeValue);
                                    dayListArr[i].timing = arr;
                                    setDayList(dayListArr);
                                  }
                                }
                              }}
                              className="ri-add-line icon-hover-bg icon-hover-bg-padding-horizontal"
                            />
                          )}
                        </div>
                      );
                    })}
                </div>
              );
            })}
            <div className={classNames("d-flex", isEditTimingValue ? "clinic-timing-item-container-footer mb-3" : "")}>
              <button
                className="dialog-btn dialog-btn-type-bordered me-2"
                onClick={() => {
                  if (isEditTimingValue) {
                    closeTiming();
                  }
                }}
              >
                {isEditTimingValue ? t("btnCancel") : t("labelPrevious")}
              </button>
              <button
                type="button"
                style={{ backgroundColor: "#DF5551" }}
                className="btn dialog-btn dialog-btn-type-filled"
                disabled={disableButton()}
                onClick={() => {
                  if (isEditTimingValue) {
                    updateTiming(true);
                  }
                }}
              >
                {isEditTimingValue ? t("saveChanges") : t("btnNext")}
              </button>
            </div>
          </div>
        </React.Fragment>
      </div>
    );
  }
}

export default DoctorTiming;
